
import React, { useEffect, useMemo, useState } from "react";
//import { Container, Row, Col, Card, CardBody, Button } from "reactstrap"
import { Container, Row, Col, Card, CardBody, Button, Badge } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { ToastContainer } from "react-toastify";


import ChangePasswordModal from "./partials/modals/ChangePasswordModal";

import {
   
    changePassword as onChangePassword,
    enableTwoFactor as onEnableTwoFactor,
    disableTwoFactor as onDisableTwoFactor,
   
} from "store/actions";

const SecurityPage = () => {
    document.title = "Sécurité & Accès | CinzanEdu"

    const [is2FAEnabled, setIs2FAEnabled] = useState(false);

    const dispatch = useDispatch();

    
    const twoFactor = JSON.parse(localStorage.getItem("twoFactor"));
     // Montage du composant
    useEffect(() => {
       
        if (twoFactor) {
           setIs2FAEnabled(twoFactor);
        }
    }, [is2FAEnabled]);


    // Multiple modals state
    const [modals, setModals] = useState({
        changePassword: false,
        
    });

    // CLOSE ALL MODALS
    const closeAllModals = () => {
        setModals({ 
            changePassword: false, 
           
        });
    }

    const onClickChangePassword = () =>{

        //setAccount(account);
        
        setModals({ 
            changePassword: true, 
            
        }) ;
       
    }

     // --- Double Authentification ---
  

  const handleToggle2FA = () => {
    if (is2FAEnabled) {
      console.log("Désactivation de la double authentification");
      dispatch(onDisableTwoFactor());
    } else {
      console.log("Activation de la double authentification");
      dispatch(onEnableTwoFactor());
    }

    setIs2FAEnabled(!is2FAEnabled);
  };

    const handleChangePassword = () => {
        console.log("Modifier le mot de passe")
    }

  const handleEnable2FA = () => {
    console.log("Activer la double authentification")
  }

  const handleDisconnectDevice = (device) => {
    console.log("Déconnecter :", device)
  }

  return (
    <div className="security-page my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <div className="header text-center mb-5">
              <h1 className="fw-bold">Sécurité & Accès</h1>
              <p className="text-muted">
                Gérez la sécurité de votre compte et vos connexions.
              </p>
            </div>

            {/* ---- Section Mot de passe ---- */}
            <Card className="mb-4 shadow-sm border-0">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4>Mot de passe</h4>
                    <p className="text-muted mb-0">
                      Changez votre mot de passe pour renforcer la sécurité de votre compte.
                    </p>
                  </div>
                  <Button color="primary" onClick={onClickChangePassword}>
                    Modifier le mot de passe
                  </Button>
                </div>
              </CardBody>
            </Card>

            {/* ---- Section Double Auth ---- */}
            {/*<Card className="mb-4 shadow-sm border-0">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4>Double authentification</h4>
                    <p className="text-muted mb-0">
                      Activez la vérification en deux étapes pour plus de sécurité.
                    </p>
                  </div>
                  <Button color="primary" onClick={handleEnable2FA}>
                    Activer la double authentification
                  </Button>
                </div>
              </CardBody>
            </Card>/}


            {/* ---- DOUBLE AUTH ---- */}
            <Card className="mb-4 shadow-sm border-0">
              <CardBody>
                <div className="d-flex justify-content-between align-items-start flex-wrap">
                  <div className="me-3">
                    <h4 className="fw-bold mb-2">Double authentification</h4>
                    <p className="text-muted mb-2">
                      Activez la vérification en deux étapes pour plus de sécurité.
                    </p>
                    <Badge color={is2FAEnabled ? "success" : "secondary"}>
                      {is2FAEnabled ? "Activée" : "Désactivée"}
                    </Badge>
                  </div>

                  <Button
                    color={is2FAEnabled ? "danger" : "primary"}
                    className="mt-3 mt-md-0"
                    onClick={handleToggle2FA}
                  >
                    <i
                      className={`bx ${
                        is2FAEnabled ? "bx-lock-open" : "bx-lock-alt"
                      } me-2`}
                    ></i>
                    {is2FAEnabled
                      ? "Désactiver la double authentification"
                      : "Activer la double authentification"}
                  </Button>
                </div>
              </CardBody>
            </Card>

            {/* ---- Appareils connectés ---- */}
            {/*<Card className="mb-4 shadow-sm border-0">
              <CardBody>
                <div className="mb-3">
                  <h4>Appareils connectés</h4>
                  <p className="text-muted">
                    Liste des appareils où vous êtes actuellement connecté.
                  </p>
                </div>

                <div className="device-list">
                  <div className="device-item d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6 className="mb-1 fw-semibold">MacBook Pro (Safari)</h6>
                      <p className="text-muted mb-0 small">
                        Dakar, Sénégal – 102.88.44.12 <br />
                        Connecté le 14/10/2025 18:22:00
                      </p>
                    </div>
                    <span className="badge bg-success">Appareil actuel</span>
                  </div>

                  <div className="device-item d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6 className="mb-1 fw-semibold">iPhone 15 (Chrome)</h6>
                      <p className="text-muted mb-0 small">
                        Abidjan, Côte d’Ivoire – 102.91.33.8 <br />
                        Connecté le 12/10/2025 10:45:00
                      </p>
                    </div>
                    <Button
                      color="outline-danger"
                      size="sm"
                      onClick={() => handleDisconnectDevice("iPhone 15")}
                    >
                      Déconnecter
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Card>*/}

            {/* ---- Historique des connexions ---- */}
            {/*<Card className="shadow-sm border-0">
              <CardBody>
                <div className="mb-3">
                  <h4>Historique des connexions</h4>
                  <p className="text-muted">
                    Consultez vos dernières connexions pour détecter une activité suspecte.
                  </p>
                </div>

                <div className="history-list">
                  <div className="d-flex justify-content-between border-bottom py-2">
                    <span>2025-10-14 18:22</span>
                    <span>102.88.44.12</span>
                    <span>Dakar</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom py-2">
                    <span>2025-10-12 10:45</span>
                    <span>102.91.33.8</span>
                    <span>Abidjan</span>
                  </div>
                  <div className="d-flex justify-content-between py-2">
                    <span>2025-10-10 21:10</span>
                    <span>154.55.12.77</span>
                    <span>Lomé</span>
                  </div>
                </div>
              </CardBody>
            </Card>*/}
          </Col>
        </Row>

        <ChangePasswordModal
            isOpen={modals.changePassword}
            toggle={closeAllModals}
            //roles={roles}
            onSubmit={(values) => {
                dispatch(onChangePassword(values));
                closeAllModals();
            }}
        />
        <ToastContainer />
      </Container>
    </div>
  )
}

export default SecurityPage
